var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteblob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5277",
    d: "M28.5,-50.4C36.9,-44.6,43.5,-36.7,51.3,-28C59.1,-19.3,68,-9.6,71.6,2.1C75.1,13.7,73.3,27.5,67.4,39.6C61.6,51.7,51.7,62.1,39.8,69.4C27.9,76.6,14,80.6,0.7,79.5C-12.7,78.3,-25.3,72.1,-39.7,66.3C-54.1,60.5,-70.2,55.1,-74.2,44.2C-78.2,33.2,-70.1,16.6,-65.9,2.5C-61.6,-11.7,-61.2,-23.4,-57,-34.1C-52.9,-44.8,-45,-54.6,-34.9,-59.4C-24.8,-64.3,-12.4,-64.1,-1.2,-62.1C10.1,-60.1,20.2,-56.2,28.5,-50.4Z",
    transform: "translate(100 100)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteblob);
export default __webpack_public_path__ + "static/media/quoteblob.24c8a255bc1e5d2a4efc09b2b6fc1d6b.svg";
export { ForwardRef as ReactComponent };